<template>
  <div id="addMember">
    <div class="title">
      <h2>员工管理</h2>
    </div>
    <div class="header">
      <span><i class="el-icon-warning-outline"></i>如需新增职员，点击“邀请职员加入”，或通知职员登录平台申请加入。</span>
      <el-button type="primary" size="mini" @click="dialogVisible = true">邀请员工加入</el-button>
    </div>
    <div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :height="TableHeight"
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <el-table-column prop="account" label="账号">
        </el-table-column>
        <el-table-column prop="name" label="姓名">
        </el-table-column>
        <el-table-column prop="tel" label="手机号"> </el-table-column>
        <el-table-column prop="department" label="部门"> </el-table-column>
        <el-table-column label="状态">
          <template slot-scope='scope'>
          <p v-if="scope.row.status !='1'" style="color: red;">未验证</p>
          <p v-else>已验证</p>
        </template>
        </el-table-column>
        <el-table-column prop="register_time" label="注册时间"> </el-table-column>
      </el-table>
        <!-- 分页 -->
      <div class="block">
        <el-pagination
          class="pagination"
          @current-change="currentChangeHandle"
          background
          :current-page="currentPage1"
          :page-size="pageSize"
          layout="prev, pager, next, slot, jumper"
          :total="currentPage4"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      v-dialogDrag
      title="邀请员工加入"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
    <div v-if="isShow">
        <span class="tel">请输入员工手机号</span>
      <div>
        <el-input placeholder="请输入手机号" size="mini" v-model="tel" @blur="getPhone"></el-input>
      </div>
      <span slot="footer" class="dialog-footer" style="display: flex;justify-content: center;margin-top: 200px;">
        <el-button type="primary" @click="nextStep" size="mini" :disabled="disabled" style="width: 130px;">下一步</el-button>
      </span>
    </div>
    <div v-else>
        <span class="tel">请选择邀请方式</span>
        <div class="interlinkage">
          <div>
            <h1>分享链接</h1>
            <p>发送以下链接，对方同意后即可加入公司</p>
            <p class="link">链接:{{ verify_url }}</p>
          </div>
          <el-button type="primary" size="mini" style="width: 130px;" @click="copy" v-copy="verify_url">复制邀请链接</el-button>
        </div>
        <!-- <div class="interlinkage">
            <div>
                <h1>发送短信</h1>
                <p>发送邀请链接短信到员工手机</p>
            </div>
            <el-button type="primary" size="mini" style="width: 130px;">发送短信</el-button>
        </div> -->
    </div>

    </el-dialog>
  </div>
</template>
  
  <script scoped>
import { companyinvitestaff,companystaff } from "../../static/API/API.js";
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      TableHeight: 490,
      dialogVisible: false,
      tel:'',
      isShow:true,
      disabled:true,
      verify_url:'',
      currentPage4: 0,
      currentPage1: 1,
      currentPage: 10,
      pageSize: 1,
      pattern:'',
      keywords:''
    };
  },
  methods: {
    pagefeed() {
        this.loading = true
        let params = new URLSearchParams()
        params.append('field', this.pattern)
        params.append('keyword', this.keywords)
        params.append('page_size', this.currentPage)
        params.append('page_number', this.currentPage1)
        this.$axios.get(companystaff,{params}).then(res => {
          console.log(res);
          this.tableData = res.data[0]['pagedata']
          this.currentPage4 = Number(res.data[0]['PageNums'])
          this.keywords = ''
          setTimeout(() => {
            this.loading = false
          }, 300);
        })
      },
    // 手机号校验
    getPhone(){
      var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
       if (!phonereg.test(this.tel)) {
        this.$message({
            message: '手机号格式错误,请重新输入！',
            type: 'error',
            duration: 1000,
            showClose: true,
          });
         return false
       } else {
        this.disabled = false
       }
    },
    // 下一步
    nextStep(){
      let params = new URLSearchParams();
        params.append('staff_tel',this.tel);//s手机号
      this.$axios.post(companyinvitestaff,params).then(res => {
        console.log(res);
        if(typeof(res.data) == 'object'){
          this.verify_url = res.data.verify_url
          this.isShow = false
        }else{
          this.$message({
            type: 'error',
            message:res.data,
            duration: 1000,
            showClose: true,
          });
        }
        })
    },
          // 改变当前所在页
    currentChangeHandle(val) {
        this.currentPage1 = val
        this.pagefeed()
      },
    // 复制链接
    copy(){
      setTimeout(()=>{
        this.$message({
            type: 'success',
            message:'复制成功',
            duration: 1000,
            showClose: true,
      });
      },200)
    },
    getHeight() {
      //动态计算表格高度
      this.$nextTick(() => {
        let windowHeight =
          document.documentElement.clientHeight || document.bodyclientHeight;
        this.TableHeight = windowHeight - 299; //数值"140"根据需要调整
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          this.isShow = true
          this.tel = ''
          this.disabled = true
        })
        .catch((_) => {});
    },
  },
  mounted() {
    this.getHeight();
    this.pagefeed()
  },
  created() {
    window.addEventListener("resize", this.getHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
};
</script>
  
<style scoped>
.title {
  padding-bottom: 10px;
  margin-bottom: 25px;
  border-bottom: 1px solid #e7e7e7;
}
.header {
  display: flex;
  justify-content: space-between;
  padding-right: 20px;
  margin-bottom: 25px;
}
.header span {
  font-size: 14px;
}
.tel{
    display: inline-block;
    margin-bottom: 20px;
    font-size: 15px;
    margin-top: 20px;
}
.interlinkage{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: #eee 1px solid;
  padding: 20px;
  line-height: 30px;
  margin-bottom: 20px;
}
.interlinkage h1{
  font-weight: bold;
  font-size: 18px;
  color: black;
}
.link{
  width: 260px;
  ord-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 这里是超出几行省略 */
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/views/addMember.vue